import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fight-covid-19/recovery/Index.vue')
const Guide = () => import('../activity/fight-covid-19/recovery/Guide.vue')

export const indexRoute: RouteConfig = {
  path: '/fight-covid-19/recovery',
  name: 'fight_covid_19_recovery',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '病毒退散 满血阳康',
  },
}

export const guideRoute: RouteConfig = {
  path: '/fight-covid-19/recovery/guide',
  name: 'fight_covid_19_recovery_guide',
  component: Guide,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '新冠康复 知识手册',
  },
}

export default [indexRoute, guideRoute]
